module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_2318712.c5e45ddd.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/FormatoSimplificado_2318712.pdf
// module id = 836
// module chunks = 0